import { Controller } from "@hotwired/stimulus"

import * as Ga4 from "@/helpers/ga4_helper"

export const ITEM_LIST_NAME = "Venue Packages"

export default class extends Controller {
  static values = { ecommerceItems: Array }
  declare readonly ecommerceItemsValue: Ga4.EcommerceItem[]

  initialize(): void {
    // Toggle mobile sticky status bar on intersection

    const packagesSection = document.getElementById("packages")
    const statusBar = document.querySelector("[data-status-bar]")
    let packagesViewed = false

    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting }) => {
          // Show/hide status bar
          statusBar?.classList.toggle("is-hidden", isIntersecting)

          // Fire GA4 event if first time seeing packages
          if (isIntersecting && !packagesViewed) {
            packagesViewed = true

            Ga4.viewItemListEvent(ITEM_LIST_NAME, this.ecommerceItemsValue)
          }
        })
      },
      { root: null, rootMargin: "-25% 0px", threshold: 0 }
    )

    if (packagesSection) {
      observer.observe(packagesSection)
    }
  }

  buyMonetaryVoucher(): void {
    Ga4.selectItemEvent({
      item_category: "Monetary Voucher",
      item_list_name: ITEM_LIST_NAME,
      item_name: "£100",
      price: 100,
      quantity: 1
    })

    Ga4.virtualPageViewEvent("Amount Selection", "/voucher_checkout/amount-selection")

    this.dispatch("buyMonetaryVoucher")
  }
}
